export const VIDEO_VARIANT = 'highSchool'
